<template>
  <div class="container-fluid h-100" style="overflow: hidden; overflow-y: auto">
    <b-card no-body>
      <b-card-header>
        <div v-show="errorMessage" class="alert alert-danger">
          {{ errorMessage }}
        </div>
        <b-nav-form>
          <b-nav-text>Manage Inbound Inventory Shipments for&nbsp;</b-nav-text>
          <b-form-select v-model="selectFacility" size="sm">
            <b-form-select-option :value="null" disabled
              >Select Facility</b-form-select-option
            >
            <template v-for="f in facilities">
              <b-form-select-option :value="f" :key="f">{{
                f
              }}</b-form-select-option>
            </template>
          </b-form-select>
        </b-nav-form>
      </b-card-header>
      <b-card-body>
        <b-tabs>
          <b-tab title="Add">
            <AddInboundPanel />
          </b-tab>
          <b-tab title="Find">
            <FindInboundPanel />
          </b-tab>
        </b-tabs>
      </b-card-body>
    </b-card>
    <LoadingSplash />
  </div>
</template>

<script>
import LoadingSplash from "../LoadingSplash.vue";
import FindInboundPanel from "./FindInboundPanel.vue";
import AddInboundPanel from "./AddInboundPanel.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    LoadingSplash,
    FindInboundPanel,
    AddInboundPanel,
  },
  data() {
    return {
      selectFacility: null,
      facilities: ["ADC", "MTJOY", "ATI"],
    };
  },
  computed: {
    ...mapGetters("common", ["loading", "errorMessage", "defaultFacility"]),
    ...mapGetters("invBundles", ["facility"]),
  },
  watch: {
    selectFacility(newVal) {
      if (newVal) {
        if (this.facility != newVal) {
          this.setFacility(newVal);
        }
      }
    },
    facility(newVal) {
      if (newVal) {
        if (this.selectFacility != newVal) {
          this.selectFacility = newVal;
        }
      }
    },
  },
  methods: {
    ...mapActions("common", ["setErrorMessage"]),
    ...mapActions("invBundles", ["setFacility"]),
  },
  mounted() {
    this.selectFacility = this.defaultFacility;
    this.setFacility(this.selectFacility);
    this.setErrorMessage(null);
  },
};
</script>

<style scoped></style>
